module.exports = __webpack_public_path__ + "static/media/sf-logo-square.48948437.svg";